// shared/hooks/contingencia-efatura-hook.js

import { useContext } from "react";
import { ContingenciaEfaturaContext } from "../context/contingencia-efatura-context";

export const useContingenciaEfatura = () => {
  const context = useContext(ContingenciaEfaturaContext);

  if (!context) {
    throw new Error(
      "useContingenciaEfatura deve ser usado dentro de ContingenciaEfaturaProvider"
    );
  }

  return context;
};
